<div class="search-field">
    <div class="title-container">
        <span class="title">Filters</span>
        <button class="plus-btn" (click)="addFormControl()">
            <i class="bi bi-plus-square"></i>
        </button>
    </div>

    <form [formGroup]="searchFilterForm" class="form-group" (keydown.enter)="onSubmit()">
        <ng-container *ngFor="let group of searchFilterForm.controls | keyvalue; let i = index">
            <div [formGroupName]="group.key" class="f-search">
                <!-- Option select -->
                <mat-form-field>
                    <mat-select formControlName="option" >
                        <mat-option *ngFor="let option of allAvailableOptions" [value]="option">
                            {{ formatEnumKey(option) }}
                        </mat-option>
                    </mat-select>
                </mat-form-field>

                <!-- Hit rate inputs -->
                <ng-container *ngIf="searchFilterForm.get(group.key)?.get('option')?.value === 'hitRate'; else dynamicOrDefaultInput">
                    <mat-form-field class="custom-mat-input">
                        <mat-label>From</mat-label>
                        <input matInput type="number" formControlName="hitRateMin" placeholder="From" min="50" max="100" />
                    </mat-form-field>
                    <mat-form-field class="custom-mat-input">
                        <mat-label>To</mat-label>
                        <input matInput type="number" formControlName="hitRateMax" placeholder="To" min="50" max="100" />
                    </mat-form-field>
                </ng-container>

                <!-- Dynamic or default input field -->
                <ng-template #dynamicOrDefaultInput>
                    <ng-container [ngSwitch]="searchFilterForm.get(group.key)?.get('option')?.value">

                        <!-- Tuning name (separate from vehicle dynamic data) -->
                        <ng-container *ngSwitchCase="'tuningName'">
                            <mat-form-field class="custom-mat-input">
                                <mat-select formControlName="value" >
                                    <mat-option *ngFor="let tuning of tuningNames()" [value]="tuning">
                                        {{ tuning }}
                                    </mat-option>
                                </mat-select>
                            </mat-form-field>
                        </ng-container>

                        <!-- Dynamic vehicle data from backend -->
                        <ng-container *ngSwitchDefault>
                            <ng-container *ngIf="apiSearchableOptions.includes(searchFilterForm.get(group.key)?.get('option')?.value); else fallbackInput">
                                <mat-form-field class="custom-mat-input" appearance="fill">
                                    <input
                                            type="text"
                                            matInput
                                            formControlName="value"

                                            [matAutocomplete]="auto"
                                    />
                                    <mat-autocomplete #auto="matAutocomplete">
                                        <mat-option
                                                *ngFor="let val of getDynamicOptions(group.key, searchFilterForm.get(group.key)?.get('option')?.value)"
                                                [value]="val"
                                        >
                                            {{ val }}
                                        </mat-option>
                                    </mat-autocomplete>
                                </mat-form-field>
                            </ng-container>

                            <ng-template #fallbackInput>
                                <mat-form-field class="custom-mat-input">
                                    <input matInput type="text" formControlName="value" />
                                </mat-form-field>
                            </ng-template>
                        </ng-container>

                    </ng-container>
                </ng-template>

                <!-- Delete filter row -->
                <button (click)="deleteSearchBar(group.key)" [disabled]="!group.key" class="delete-btn">
                    <i class="bi bi-x-square"></i>
                </button>
            </div>
        </ng-container>

        <!-- Action buttons -->
        <div class="bs-area">
            <div class="buttons-position">
                <button class="custom-btn" (click)="onSubmit()" [disabled]="!hasFormControls() || searchFilterForm.invalid">
                    Search
                </button>
                <button class="close-btn" (click)="clearFilters()">Clear filters</button>
            </div>
            <div class="close-button">
                <button class="close-btn" (click)="closeModal()">Close</button>
            </div>
        </div>
    </form>
</div>
